const getUserToken = () => {

  const token = localStorage.getItem('userToken');
  const expireDate = localStorage.getItem('tokenExpireDate');

  if (token && expireDate) {
    const now = new Date();
    const expirationDate = new Date(expireDate);

    // Check if the token is still valid
    if (now < expirationDate) {
      return token;
    } else {
      localStorage.removeItem('userToken');
      localStorage.removeItem('tokenExpireDate');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_name');
      return null;
    }
  }

  return null;
};
export default getUserToken;
